import React, { useEffect, useState } from "react";
import Heart from "../images/icons/Heart";
import styles from "./SummonerInfo.module.css";

const imgPatch = "15.8.1";

export const SummonerInfo = ({ info, width }) => {
  const [isFavorite, setIsFavorite] = useState(false);
  useEffect(() => {
    const favorite = localStorage.getItem("favorite")
      ? JSON.parse(localStorage.getItem("favorite"))
      : [];
    favorite.forEach((f) => {
      if (f === info.name) setIsFavorite(true);
    });
  }, [info.name]);

  const toggleFavorite = (e) => {
    let favorite = localStorage.getItem("favorite")
      ? JSON.parse(localStorage.getItem("favorite"))
      : [];
    favorite = favorite.filter((r) => (r === info.name ? false : true));
    if (!isFavorite) {
      if (favorite.length > 19) favorite.shift();
      favorite.push(info.name);
    }
    setIsFavorite(!isFavorite);
    localStorage.setItem("favorite", JSON.stringify(favorite));
  };

  const updated = Math.max(Math.round(Date.now() / 1000 - info.update), 0);
  const requested = Math.max(Math.round(Date.now() / 1000 - info.request), 0);
  let lastUpdate;
  if (updated < 60) lastUpdate = updated + " secs ago";
  else if (updated < 120) lastUpdate = "1 min ago";
  else if (updated < 3600) lastUpdate = parseInt(updated / 60) + " mins ago";
  else if (updated < 7200) lastUpdate = "1 hour ago";
  else if (updated < 86400)
    lastUpdate = parseInt(updated / 3600) + " hours ago";
  else if (updated < 172800) lastUpdate = "1 day ago";
  else lastUpdate = parseInt(updated / 86400) + " days ago";
  return (
    <div className={styles[width]}>
      <div>
        <img
          src={`https://ddragon.leagueoflegends.com/cdn/${imgPatch}/img/profileicon/${info.icon ? info.icon : "29"
            }.png`}
          width="85"
          height="85"
          alt=""
        />
        <div className={styles.level}>{info.level}</div>
        <div className={styles.region}>{info.region.toUpperCase()}</div>
      </div>
      <div>
        <div className={styles["name_" + width]}>
          {info.name}{" "}
          <Heart active={isFavorite} onClick={(e) => toggleFavorite(e)} />
        </div>
        {info.s2020 && <div className={styles.pastseason}>20 {info.s2020}</div>}
        {info.s2021 && <div className={styles.pastseason}>21 {info.s2021}</div>}
        {info.s2022 && <div className={styles.pastseason}>22 {info.s2022}</div>}
        {info.s2023a && (
          <div className={styles.pastseason}>2023a {info.s2023a}</div>
        )}
        <div className={styles.rank}>
          {info.rank && (
            <>
              Ranked {parseInt(info.rank).toLocaleString()} on{" "}
              {info.region.toUpperCase()}
            </>
          )}
        </div>
        <div className={styles.updated}>Updated: {lastUpdate}</div>
        {updated > 60 &&
          width !== "xsmall" &&
          width !== "small" &&
          width !== "tiny" && (
            <div className={styles.requested}>
              • Requested: {requested} secs ago
            </div>
          )}
      </div>
    </div>
  );
};

export default SummonerInfo;
